import { useEffect, useRef, useState } from 'react';
import { Icon } from '../Icon';

export type AuthMode = 'login' | 'register' | null;

export function AuthModal({ mode, onClose, onModeChange }: { mode: AuthMode; onClose: () => void; onModeChange: (mode: Exclude<AuthMode, null>) => void }) {
  const firstInput = useRef<HTMLInputElement>(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!mode) return;
    setSubmitted(false);
    firstInput.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [mode, onClose]);

  if (!mode) return null;
  const register = mode === 'register';

  return (
    <div className="modal-layer" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="auth-modal" role="dialog" aria-modal="true" aria-labelledby="auth-modal-title">
        <button className="icon-button auth-modal__close" type="button" onClick={onClose} aria-label="Close"><Icon name="close" /></button>
        <span className="auth-modal__eyebrow">Welcome to 22Play</span>
        <h2 id="auth-modal-title">{register ? 'Create your account' : 'Log in'}</h2>
        <div className="auth-modal__tabs" role="tablist">
          <button type="button" role="tab" aria-selected={!register} className={!register ? 'is-active' : ''} onClick={() => onModeChange('login')}>Log in</button>
          <button type="button" role="tab" aria-selected={register} className={register ? 'is-active' : ''} onClick={() => onModeChange('register')}>Registration</button>
        </div>
        {submitted ? (
          <div className="auth-modal__success" role="status"><Icon name="ticket" /><strong>Demo request received</strong><p>This reconstruction uses a mock account provider and does not submit personal data.</p></div>
        ) : (
          <form onSubmit={(event) => { event.preventDefault(); setSubmitted(true); }}>
            <label><span>{register ? 'Email' : 'Login or email'}</span><input ref={firstInput} type={register ? 'email' : 'text'} required autoComplete={register ? 'email' : 'username'} /></label>
            <label><span>Password</span><input type="password" required minLength={6} autoComplete={register ? 'new-password' : 'current-password'} /></label>
            {register && <label className="auth-modal__check"><input type="checkbox" required /><span>I am at least 18 and accept the terms.</span></label>}
            <button className="primary-button auth-modal__submit" type="submit">{register ? 'Register' : 'Log in'}</button>
          </form>
        )}
      </section>
    </div>
  );
}
